export var ClassroomMemberRole;
(function (ClassroomMemberRole) {
    ClassroomMemberRole["STUDENT"] = "student";
    ClassroomMemberRole["TEACHER"] = "teacher";
    ClassroomMemberRole["NONE"] = "none";
})(ClassroomMemberRole || (ClassroomMemberRole = {}));
export var ClassroomMemberStatus;
(function (ClassroomMemberStatus) {
    ClassroomMemberStatus["ACTIVE"] = "ACTIVE";
    ClassroomMemberStatus["DECLINED"] = "DECLINED";
    ClassroomMemberStatus["INACTIVE"] = "INACTIVE";
    ClassroomMemberStatus["INVITED"] = "INVITED";
    ClassroomMemberStatus["IN_REVIEW"] = "IN_REVIEW";
    ClassroomMemberStatus["NOT_A_MEMBER"] = "NOT_A_MEMBER";
    ClassroomMemberStatus["OWNER"] = "OWNER";
})(ClassroomMemberStatus || (ClassroomMemberStatus = {}));
export var ClassroomMemberInviteSource;
(function (ClassroomMemberInviteSource) {
    ClassroomMemberInviteSource["CLASSLINK"] = "CLASSLINK";
    ClassroomMemberInviteSource["CLEVER"] = "CLEVER";
    ClassroomMemberInviteSource["EMAIL"] = "EMAIL";
    ClassroomMemberInviteSource["GOOGLE_CLASSROOM"] = "GOOGLE_CLASSROOM";
    ClassroomMemberInviteSource["NONE"] = "NONE";
})(ClassroomMemberInviteSource || (ClassroomMemberInviteSource = {}));
